import axios from 'api/axios';
import { getTokensPath } from './apiPaths';
export var getTokensDeleteRequest = function getTokensDeleteRequest(body) {
    return axios.delete(getTokensPath(), {
        data: JSON.stringify(body)
    });
};
